import React, { useContext, useEffect } from 'react';
import PresetReport from '@/pages/home/components/Preset';
import { buriedPoint } from '@/pages/home/utils/buriedPoint';
import { LayoutContext } from '@/pages/benchmark/state/LayoutContext';
import { BENCHMARK_GAME_CODE } from '@/pages/benchmark/_config/constant';
import { getLogTypeId } from '@/pages/benchmark/utils/utils';

const Preset = () => {
  const { frameType, currentMenu } = useContext(LayoutContext);
  const {
    preset_id: presetId = '',
    workspace_id: wordSpaceId = '',
    workspace_region: workSpaceRegion = '',
    team_id: teamId = '',
    extra_info: extInfo = ''
  } = currentMenu || {};
  
  // 如果有额外信息，组装presetId，组装规则<preset_id>;<workspace_id>;<workspace_region>;<team_id>
  let url = presetId;
  if (wordSpaceId && workSpaceRegion && teamId) {
    url = [presetId, wordSpaceId, workSpaceRegion, teamId].join(';');
  }

  useEffect(() => {
    if (!currentMenu) {
      return;
    }
    const { id = '', name_en: nameEn } = currentMenu || {};
    const logObj = {
      pageId: '800701',
      menuId: id,
      pageName: nameEn,
      extInfo: nameEn,
      pagePath: `/preset/report/${nameEn || ''}`,
      uidType: '', // 基准打点不包含uidType
      typeId: getLogTypeId(frameType),
    };
    buriedPoint(logObj);
  }, [currentMenu, frameType]);

  return (<PresetReport url={`${BENCHMARK_GAME_CODE}/${url}`} presetId={presetId} extInfo={extInfo} />);
};

export default Preset;